// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICalculateTotalBalanceRequestDto
 */
export interface ICalculateTotalBalanceRequestDto {
    /**
     * 
     * @type {Set<number>}
     * @memberof ICalculateTotalBalanceRequestDto
     */
    account_ids: Set<number>;
}

/**
 * Check if a given object implements the ICalculateTotalBalanceRequestDto interface.
 */
export function instanceOfICalculateTotalBalanceRequestDto(value: object): value is ICalculateTotalBalanceRequestDto {
    if (!('account_ids' in value) || value['account_ids'] === undefined) return false;
    return true;
}

export function ICalculateTotalBalanceRequestDtoFromJSON(json: any): ICalculateTotalBalanceRequestDto {
    return ICalculateTotalBalanceRequestDtoFromJSONTyped(json, false);
}

export function ICalculateTotalBalanceRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICalculateTotalBalanceRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_ids': new Set(json['accountIds']),
    };
}

export function ICalculateTotalBalanceRequestDtoToJSON(json: any): ICalculateTotalBalanceRequestDto {
    return ICalculateTotalBalanceRequestDtoToJSONTyped(json, false);
}

export function ICalculateTotalBalanceRequestDtoToJSONTyped(value?: ICalculateTotalBalanceRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountIds': Array.from(value['account_ids'] as Set<any>),
    };
}

